import { links } from 'utils/constants'

import { Post } from 'types/post'

export const handlePostClicked = (
  isOwner: boolean,
  navigation: any,
  handleAddPendingMembership: () => void,
  post: Post,
  completionId?: string,
) => {
  const postId = post.id ?? ''
  const hasSteps = post.hasSteps ?? false

  if (hasSteps) {
    navigation.navigate(links.POST_PAGE, {
      postId,
      completionId,
    })
  }
}
